import preval from 'preval.macro';

export const version = (
  'Q-Cloud_webapp2_' +
  preval`module.exports = new Date().toISOString();` +
  '_' + process.env.NODE_ENV
);